export default {
    controller: 'stepsController',
    template: require('../views/steps.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/steps.component.js